module.exports = __webpack_public_path__ + "static/media/kemptons-blank-profile-picture.af805cfe.jpg";